
class Header {
    constructor() {
		this.header = document.querySelector('.header-main');

		if (!this.header) {
			return;
		}

		this.resize();
		resizeCallbacks.push(this);
	}

	resize() {
		const headerHeight = getComputedStyle(this.header).getPropertyValue('height');
		document.documentElement.style.setProperty('--header-height', headerHeight);
	}
}
